(function () {
  var KEY = 'tk-scroll:' + location.pathname + location.search;
  var MAX_WAIT = 3000;

  function navType() {
    try {
      var entry = performance.getEntriesByType('navigation')[0];
      if (entry && entry.type) return entry.type;
    } catch (e) {}
    try {
      if (performance.navigation) return performance.navigation.type === 2 ? 'back_forward' : 'navigate';
    } catch (e) {}
    return 'navigate';
  }

  function read() {
    try {
      var raw = sessionStorage.getItem(KEY);
      if (raw == null) return null;
      var n = parseInt(raw, 10);
      return isNaN(n) ? null : n;
    } catch (e) {
      return null;
    }
  }

  function save() {
    try {
      sessionStorage.setItem(KEY, String(Math.round(window.pageYOffset || document.documentElement.scrollTop || 0)));
    } catch (e) {}
  }

  var saveTimer = null;
  window.addEventListener('scroll', function () {
    if (saveTimer) clearTimeout(saveTimer);
    saveTimer = setTimeout(save, 150);
  }, { passive: true });
  window.addEventListener('pagehide', save);

  function jumpTo(y) {
    var root = document.documentElement;
    var prev = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    window.scrollTo(0, y);
    root.style.scrollBehavior = prev;
  }

  function restore(target) {
    if (!target || target <= 0) return;
    var startedAt = Date.now();
    var aborted = false;

    function stop() {
      aborted = true;
      window.removeEventListener('wheel', stop);
      window.removeEventListener('touchstart', stop);
      window.removeEventListener('keydown', stop);
    }
    window.addEventListener('wheel', stop, { passive: true, once: true });
    window.addEventListener('touchstart', stop, { passive: true, once: true });
    window.addEventListener('keydown', stop, { once: true });

    function tick() {
      if (aborted) return;
      var maxY = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      jumpTo(Math.min(target, maxY));
      if (maxY < target && Date.now() - startedAt < MAX_WAIT) {
        requestAnimationFrame(tick);
      } else if (Date.now() - startedAt < 900) {
        setTimeout(tick, 120);
      } else {
        stop();
      }
    }

    tick();
  }

  if (navType() === 'back_forward') {
    var stored = read();
    if (stored) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { restore(stored); });
      } else {
        restore(stored);
      }
    }
  }

  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var y = read();
    if (y) restore(y);
  });
})();
